import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useLanguage } from '../contexts/LanguageContext';
import ContactFormModal from './ContactFormModal';

const PrivacyPage = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const [showContactModal, setShowContactModal] = useState(false);

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#f3f4f6',
      padding: '2rem 1rem'
    }}>
      <Helmet>
        <title>Privacy Policy | Qwixx Online</title>
        <meta name="description" content="Privacy policy for Qwixx Online - Learn how we collect, use, and protect your data when playing Qwixx online." />
        <link rel="canonical" href="https://qwixx-online.nl/privacy" />
      </Helmet>

      <div style={{
        maxWidth: '900px',
        margin: '0 auto',
        backgroundColor: 'white',
        borderRadius: '0.5rem',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        padding: '2rem'
      }}>
        {/* Header */}
        <div style={{
          borderBottom: '2px solid #e5e7eb',
          paddingBottom: '1.5rem',
          marginBottom: '2rem'
        }}>
          <h1 style={{
            fontSize: '2rem',
            fontWeight: 'bold',
            color: '#1f2937',
            marginBottom: '0.5rem',
            textAlign: 'center'
          }}>
            {t('privacy.title')}
          </h1>
          <p style={{
            fontSize: '0.875rem',
            color: '#6b7280',
            textAlign: 'center'
          }}>
            {t('privacy.lastUpdated')}: {t('privacy.lastUpdatedDate')}
          </p>
        </div>

        {/* Privacy Sections */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
          {Array.from({ length: 7 }, (_, i) => (
            <div key={i} style={{
              padding: '1.5rem',
              backgroundColor: '#f9fafb',
              borderRadius: '0.5rem',
              borderLeft: '4px solid #10b981'
            }}>
              <h2 style={{
                fontSize: '1.25rem',
                fontWeight: '600',
                color: '#1f2937',
                marginBottom: '0.75rem'
              }}>
                {t(`privacy.sections.${i}.title`)}
              </h2>
              <p style={{
                fontSize: '1rem',
                color: '#4b5563',
                lineHeight: '1.7',
                whiteSpace: 'pre-line'
              }}>
                {t(`privacy.sections.${i}.content`)}
              </p>
              {/* Add contact button for the Contact section (index 6) */}
              {i === 6 && (
                <button
                  onClick={() => setShowContactModal(true)}
                  style={{
                    marginTop: '1rem',
                    padding: '0.75rem 1.5rem',
                    backgroundColor: '#3b82f6',
                    color: 'white',
                    border: 'none',
                    borderRadius: '0.375rem',
                    fontSize: '1rem',
                    fontWeight: '600',
                    cursor: 'pointer'
                  }}
                >
                  {t('contact.linkText')}
                </button>
              )}
            </div>
          ))}
        </div>

        {/* Contact Form Modal */}
        <ContactFormModal
          isOpen={showContactModal}
          onClose={() => setShowContactModal(false)}
        />

        {/* Back Button */}
        <div style={{ marginTop: '2rem', textAlign: 'center' }}>
          <button
            onClick={() => navigate('/')}
            style={{
              background: 'none',
              border: 'none',
              color: '#3b82f6',
              fontSize: '1rem',
              cursor: 'pointer',
              textDecoration: 'underline'
            }}
          >
            {t('common.backToHome')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
